module.exports = __webpack_public_path__ + "img/currency8.83791a98.png";